const firebaseConfig = {
	apiKey: 'AIzaSyD96lPF0EVhOFE45vxS99hUYGnF4Sf6kjw',
	authDomain: 'exploringdream-bd0fe.firebaseapp.com',
	projectId: 'exploringdream-bd0fe',
	storageBucket: 'exploringdream-bd0fe.appspot.com',
	messagingSenderId: '511050734780',
	appId: '1:511050734780:web:5ad4b63972ca380720c4b9',
};

export default firebaseConfig;
